import React, { useState, useEffect } from 'react';
import { Button, Form, Space, Upload, UploadFile, message, Image } from 'antd';
import { Captcha } from 'gyyx-component-lib';
import { ValidData } from 'gyyx-component-lib/es/interface';
import { useOutletContext } from 'react-router-dom';
import BaseForm from '@/components/BaseForm';
import ErrorTips from '@/components/ErrorTips';
import KfLayout from '@/components/KfLayout';
import Nav from '@/components/Nav';
import { K_F_BID, RESPONSE_STATUS, UPLOAD_BUSINESS } from '@/constants';
import { KfUploadFile, submitUnsealApplication } from '@/services/kf';
import { LoginInfo, IServerVal } from '@/types';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';
import SuccessModal from '../successModal';
import './index.less';
import { UploadOutlined } from '@ant-design/icons';
function isVideoUrl(url: string,splitVal:string = '/') {
    const videoExtensions: string[] = ['mp4', 'webm', 'ogg', 'mp3', 'wav', 'avi', 'mov', 'mpeg', '3gp', 'mkv'];
    const extension: string = (url?.split(splitVal)?.pop()?.toLowerCase() as string);
    return videoExtensions.includes(extension);
}
const UnsealApplication = () => {
    const [visible, setVisible] = useState(false);
    const [successStatus, setSuccessStatus] = useState(false);
    const [errorTips, setErrorTips] = useState('');
    const [form] = Form.useForm();
    const loginInfo = useOutletContext() as LoginInfo;
    const setUpdateLogin = useSetAtom(loginAtom);
    const [previewOpen, setPreviewOpen] = useState<boolean>(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any>([
        // {
        //   uid: '0',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        //   thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        //   percent: 33,
        // },
        // {
        //   uid: '-1',
        //   name: 'yyy.mp4',
        //   status: 'done',
        //   url: 'https://s.xiaopeng.com/xp-fe/mainsite/intelligent-tech/p3-1.mp4',
        //   thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // },
    ]);


    useEffect(() => {
        if (!loginInfo?.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true });
        }
    }, [loginInfo?.isLogin]);

    const getBase64 = (file: any): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as any);
        }
        setPreviewImage(file.response.data);
        setPreviewOpen(true);
    };
    const uploadvideo = async (value: any) => {
        const { file, fileList } = value
        // const resblob = await fetch(value.thumbUrl).then((res) => res.blob())
        let FileUrl = URL.createObjectURL(file.originFileObj) //文件转bold流
        let videoElenment = document.createElement('video');//创建一个视频控件
        videoElenment.src = FileUrl;//控件视频地址
        videoElenment.autoplay = true;//是否自动播放
        videoElenment.addEventListener("canplay", function () {//监听播放
            let canvas = document.createElement('canvas');//创建一个画板
            canvas.width = videoElenment.videoWidth * 0.8;//画板宽
            canvas.height = videoElenment.videoHeight * 0.8;//画板的高
            //通过画板的drawImage属性对图片进行处理
            canvas?.getContext('2d')?.drawImage(videoElenment, 0, 0, canvas.width, canvas.height);
            //处理完毕通过toDataURL属性转为图片格式拿去base64图片路径
            let imgs = canvas.toDataURL('image/png')
            // 返回base64图
            // fileList[fileList.length-1].thumbUrl = imgs
            fileList.filter((item: any) => item.uid == file.uid)[0].thumbUrl = imgs
            
            setFileList([...fileList])
        })
    }

    const uploadCustomRequest = (options: any) => {
        // if(uploadLock){
        //   message.error('请等待前一个文件上传完成')
        //   return 
        // }

        const { file, onSuccess } = options;
        if (options.file.size / 1024 / 1024 > 100) {
            message.error('只能上传100M文件');
            return;
        }
        if (fileList.length > 10) {
            message.error('只能上传10个文件哦');
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('businessType', UPLOAD_BUSINESS);
        KfUploadFile(formData).then((res) => {
            if (res.status == 500) {
                 message.error('上传失败')

            }
            if (res.retCode == 'SUCCESS') {
                onSuccess(res)
                message.success('上传成功')

                onSuccess({ ...res, file })
            } else if (res.retCode == 'STATUS_ERROR') {
                message.error(res.message);
            }
        }).catch((error) => {
            message.error(error.message);
        }).finally(() => {
            // changeuploadlock(false)
        })
    }
    const getConditions = () => {
        return [
            {
                label: <>被问账号<span className="custom_required">*</span></>,
                type: 'TEXT',
                name: 'askAccount',
                key: 'askAccount',
                render: () => <div>{loginInfo.account}</div>,
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>游戏<span className="custom_required">*</span></>,
                type: 'SELECT',
                name: 'gameId',
                key: 'gameId',
                options: {
                    placeholder: '请选择',
                    options: [
                        {
                            label: '问道',
                            value: 2
                        }
                    ]
                },
                rules: [
                    {
                        required: true,
                        message: '必填',
                    }
                ],
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>服务器<span className="custom_required">*</span></>,
                type: 'GAME_SERVER',
                name: 'serverId',
                key: 'serverId',
                options: {
                    serIptClassName: 'sever_input',
                    serSelClassName: 'sever_sel_btn',
                    status: 'activation',
                    isWeGame: true,
                    gameId: 2,
                    setValueFn: (item: IServerVal) => {
                        form.setFieldsValue({ serverId: item.code });
                    }
                },
                rules: [
                    {
                        required: true,
                        message: '必填',
                    }
                ],
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>角色名称<span className="custom_required">*</span></>,
                type: 'INPUT',
                name: 'role',
                key: 'role',
                rules: [
                    {
                        required: true,
                        message: '必填'
                    },
                    {
                        whitespace: true,
                        message: '必填'
                    }
                ],
                itemOptions: {
                    colon: false
                },
                options: {
                    maxLength: 30
                }
            },
            {
                label: <>上传证明</>,
                type: 'COMPACT',
                key: 'authPhoto',
                name: 'authPhoto',
                options: {
                    children: <Space.Compact style={{ position: 'relative' }}>
                        <Form.Item
                            name='files' style={{ marginBottom: '10px', minWidth: '400px' }}>
                            <Upload
                                maxCount={10}
                                listType="picture"
                                beforeUpload={(file) => {
                                    if (fileList.length >= 10) {
                                        message.error('只能上传10个文件');
                                        return false
                                    }
                                    if (file.size / 1024 / 1024 > 100) return false

                                }}
                                customRequest={uploadCustomRequest}
                                fileList={fileList}
                                onPreview={handlePreview}
                                onChange={(optopn: any) => {
                                    const { fileList: newFileList } = optopn;
                                    if (optopn.file.size / 1024 / 1024 > 100) {
                                        message.error('只能上传100M文件');
                                        return;
                                    }
                                    // 是否视频
                                    if (optopn.file.status == 'done' && isVideoUrl(optopn.file.type)) {
                                        uploadvideo(optopn)
                                    } else { setFileList(newFileList); }

                                }}
                            >
                                <Button icon={<UploadOutlined />}>附件</Button>
                            </Upload>
                        </Form.Item>
                        <div className='notes'>备注: 未要求上传相关证明的，无需上传附件，具体以工作人员给您的回复为准</div>
                    </Space.Compact>,
                },
            },
            {
                label: <>问题内容<span className="custom_required">*</span></>,
                type: 'TEXTAREA',
                name: 'note',
                key: 'note',
                itemOptions: {
                    className: 'form_item_textarea',
                    colon: false
                },
                options: {
                    autoSize: { minRows: 6, maxRows: 6 },
                    style: { width: '400px' },
                    maxLength: 200
                },
                rules: [
                    {
                        required: true,
                        message: '必填'
                    },
                    {
                        whitespace: true,
                        message: '必填'
                    }
                ]
            },
            {
                label: '解封申明',
                type: 'TEXT',
                key: 'unseal_tip',
                render: () => <div className="unseal_tip">账号涉嫌违规，以后将会按照用户协议及游戏规则进行游戏，不再进行违规操作，如再次出现类似行为，将承担由此带来的一切后果。</div>,
                itemOptions: {
                    colon: false
                }
            }
        ];
    }

    const submitCaptch = async (data: ValidData) => {
        setVisible(false);
        const { captcha, cookies, balanceCode } = data;
        const values = form.getFieldsValue();
        const params = {
            ...values,
            files:fileList.map((file: {response: any}) => file.response.data),  
            captcha,
            cookies,
            balanceCode,
            bid: K_F_BID
        }
        const res = await submitUnsealApplication(params);
        if (res.retCode === RESPONSE_STATUS.SUCCESS) {
            setSuccessStatus(true);
        } else {
            if (res.data?.error === 'NoLoginError') {
                setUpdateLogin?.({ isLogin: false, visibleLogin: true });
            } else {
                setErrorTips(res.message);
            }
        }
    }

    const onFinish = () => {
        if (!loginInfo?.isLogin) {
            setUpdateLogin?.({ isLogin: false, visibleLogin: true });
            return;
        }
        form.validateFields().then(() => {
            setVisible(true);
        }).catch((error) => {
            console.log(error);
        });
    }

    const onReset = () => {
        form.resetFields();
    }

    return (
        <div className="unseal_application">
            <Nav activeMenu="kfCenter" />
            <KfLayout title="游戏解封申请">
                {successStatus ?
                    <SuccessModal title="提交解封申请成功,请耐心等待客服处理">
                        <div className="succ_tip">
                            <span>工作人员预计在</span>
                            <span style={{ color: 'red' }}>1个工作日内</span>
                            <span>处理完毕，请随时留意客服中心的处理进度！</span>
                        </div>
                    </SuccessModal> :
                    <div>
                        {errorTips && <ErrorTips content={errorTips} />}
                        <BaseForm form={form} conditions={getConditions()} onFinish={onFinish} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} />
                        <div className="btn_group">
                            <div className="submit btn" onClick={onFinish}>确认</div>
                            <div className="reset btn" onClick={onReset}>清空</div>
                        </div>
                    </div>
                }
            </KfLayout>
            <Captcha
                visible={visible}
                bId={K_F_BID}
                onSubmit={submitCaptch}
                onClose={() => setVisible(false)}
            />
            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        imageRender: () => {
                            if (isVideoUrl(previewImage,'.')) {
                                return (
                                    <video
                                        muted
                                        width="700"
                                        height="400"
                                        controls={true}
                                        src={
                                            previewImage
                                        }
                                        onContextMenu={(event) => event.preventDefault()}
                                    />
                                );
                            } else {
                                return (
                                    <img
                                        style={{ maxWidth: '800px', maxHeight: '800px' }}
                                        src={
                                            previewImage
                                        }
                                        alt=""
                                        onContextMenu={(event) => event.preventDefault()}
                                    />
                                );
                            }
                        },
                        toolbarRender: () => null,
                    }}
                    src={previewImage}
                />
            )}
        </div>
    )
}

export default UnsealApplication;